import BaseDialog from './Index.vue'

BaseDialog.install = function(Vue) {
  Vue.component(BaseDialog.name, BaseDialog)
}

export default BaseDialog
